module.exports = __webpack_public_path__ + "img/pic_12.73acf02c.jpg";